import { authenticatedFetch } from '../utils/fetchUtils';

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '')) + "/api/astrology";

export const askQuestion = async (question, session = '', proMode = false) => {
  const response = await authenticatedFetch(`${BASE_URL}/ask`, {
    method: 'POST',
    body: JSON.stringify({ question, session, proMode }),
  });

  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(responseData.message || 'Failed to get a response.');
  }

  if (responseData.error === 'NO_CREDITS' || responseData.error === 'INSUFFICIENT_CREDITS_FOR_PRO') {
    const error = new Error(responseData.message);
    error.code = responseData.error;
    error.credits = responseData.credits;
    throw error;
  }

  return responseData;
};

export const submitFeedback = async (session, question, feedback) => {
  try {
    await authenticatedFetch(`${BASE_URL}/feedback`, {
      method: 'POST',
      body: JSON.stringify({ session, question, feedback }),
    });
  } catch {
    // Fire-and-forget
  }
};

export const getSessions = async () => {
  const response = await authenticatedFetch(`${BASE_URL}/sessions`);
  if (!response.ok) return [];
  const data = await response.json();
  return data.sessions;
};

export const getSessionMessages = async (sessionId) => {
  const response = await authenticatedFetch(`${BASE_URL}/sessions/${encodeURIComponent(sessionId)}`);
  if (!response.ok) return [];
  const data = await response.json();
  return data.messages;
};

export const getDailyHoroscope = async () => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/daily-horoscope`);
    if (!response.ok) return null;
    return response.json();
  } catch {
    return null;
  }
};
